export const contactList = [
    {
        name: 'West Coast / Intl. Sales: Adam Combs (Head)',
        email: 'adam.combs@matrix-lighting.com',
        phone: {
            url: '+19092239845',
            text: '(909) 223-9845',
        },
    },
    {
        name: 'East Coast Sales: Austin Radney',
        email: 'austin@matrix-lighting.com',
        phone: {
            url: '+18134367287',
            text: '(813) 436-7287',
        },
    },
    {
        name: 'Midwest Sales: Matt Sulejmani',
        email: 'matt@matrix-lighting.com',
        phone: {
            url: '+17345467456',
            text: '(734) 546-7456',
        },
    },
    {
        name: 'Technical Support: Chris Charniga',
        email: 'chris@matrix-lighting.com',
        phone: {
            url: '+14193095596',
            text: '(419) 309-5596',
        },
    }
];